const TestIdPlugin = {
    install(app) {
        if (this.installed) {
            return;
        }

        this.installed = true;

        app.mixin({
            beforeCreate() {
                if (this.$options && this.$options.testIdOptions) {
                    const { keyPrefix = null } = this.$options.testIdOptions;

                    this.testIdOptions = {
                        keyPrefix,
                    };
                }
            },
        });

        app.config.globalProperties.$testId = function (id) {
            if (!this.testIdOptions.keyPrefix) return id;
            return `${this.testIdOptions.keyPrefix}.${id}`;
        };
    },
};

export default TestIdPlugin;
